<template>
  <b-modal
    id="convert-lead-modal"
    v-model="showModal"
    title="Chuyển đổi khách hàng"
    size="lg"
  >
    <div v-if="lead">
      <!-- Tab Navigation -->
      <b-tabs v-model="activeTab" content-class="mt-3">
        <!-- Individual Customer Tab -->
        <b-tab title="Khách hàng cá nhân" active>
          <div class="p-3">
            <h5 class="mb-3">Thông tin khách hàng cá nhân</h5>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="form-label"
                    >Họ và tên <span class="text-danger">*</span></label
                  >
                  <b-form-input
                    v-model="formData.fullName"
                    :readonly="isConverted"
                    :placeholder="lead.fullName || 'Nhập họ và tên'"
                    required
                  ></b-form-input>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="form-label"
                    >Số điện thoại <span class="text-danger">*</span></label
                  >
                  <b-form-input
                    v-model="formData.phoneNumber"
                    :readonly="isConverted"
                    :placeholder="lead.phoneNumber || 'Nhập số điện thoại'"
                    required
                  ></b-form-input>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="form-label">Email</label>
                  <b-form-input
                    v-model="formData.email"
                    type="email"
                    :readonly="isConverted"
                    :placeholder="lead.email || 'Nhập email'"
                  ></b-form-input>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="form-label">Địa chỉ</label>
                  <b-form-textarea
                    v-model="formData.address"
                    :readonly="isConverted"
                    :placeholder="lead.address || 'Nhập địa chỉ'"
                    rows="2"
                  ></b-form-textarea>
                </div>
              </div>
            </div>

            <div v-if="!canConvertAsIndividual" class="alert alert-warning">
              <i class="fas fa-exclamation-triangle"></i>
              Thiếu thông tin bắt buộc: Họ tên và số điện thoại
            </div>
          </div>
        </b-tab>

        <!-- Business Customer Tab -->
        <b-tab title="Khách hàng doanh nghiệp">
          <div class="p-3">
            <h5 class="mb-3">Thông tin khách hàng doanh nghiệp</h5>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="form-label"
                    >Tên công ty <span class="text-danger">*</span></label
                  >
                  <b-form-input
                    v-model="formData.companyName"
                    :placeholder="lead.companyName || 'Nhập tên công ty'"
                    required
                    :readonly="isConverted"
                  ></b-form-input>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="form-label"
                    >Mã số thuế <span class="text-danger">*</span></label
                  >
                  <b-form-input
                    v-model="formData.taxCode"
                    :placeholder="lead.taxCode || 'Nhập mã số thuế'"
                    required
                    :readonly="isConverted"
                  ></b-form-input>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="form-label"
                    >Người liên hệ <span class="text-danger">*</span></label
                  >
                  <b-form-input
                    v-model="formData.fullName"
                    :placeholder="lead.fullName || 'Nhập tên người liên hệ'"
                    required
                    :readonly="isConverted"
                  ></b-form-input>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="form-label"
                    >Số điện thoại <span class="text-danger">*</span></label
                  >
                  <b-form-input
                    v-model="formData.phoneNumber"
                    :placeholder="lead.phoneNumber || 'Nhập số điện thoại'"
                    required
                    :readonly="isConverted"
                  ></b-form-input>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="form-label">Email</label>
                  <b-form-input
                    v-model="formData.email"
                    type="email"
                    :placeholder="lead.email || 'Nhập email'"
                    :readonly="isConverted"
                  ></b-form-input>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="form-label">Địa chỉ</label>
                  <b-form-textarea
                    v-model="formData.address"
                    :placeholder="lead.address || 'Nhập địa chỉ'"
                    rows="2"
                    :readonly="isConverted"
                  ></b-form-textarea>
                </div>
              </div>
            </div>

            <div v-if="!canConvertAsBusiness" class="alert alert-warning">
              <i class="fas fa-exclamation-triangle"></i>
              Thiếu thông tin bắt buộc: Tên công ty, mã số thuế, người liên hệ
              và số điện thoại
            </div>
          </div>
        </b-tab>
      </b-tabs>
      <div
        v-if="isConverted"
        class="alert alert-success d-flex align-items-center"
      >
        <i class="fas fa-check-circle alert-success"></i>
        <b>Lead đã được chuyển đổi</b>
      </div>
    </div>

    <!-- Footer Actions -->
    <template v-slot:modal-footer>
      <div class="d-flex justify-content-between w-100">
        <b-button variant="secondary" @click="closeModal" :disabled="loading">
          Hủy
        </b-button>
        <b-button
          variant="primary"
          @click="handleConvert"
          :disabled="!canConvert || loading"
          :class="{ 'spinner-border-sm': loading }"
        >
          <span
            v-if="loading"
            class="spinner-border spinner-border-sm mr-2"
          ></span>
          Chuyển đổi
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { LeadModel } from '@/core/models';
import { CONVERTED_CUSTOMER_TYPE } from '@/utils/enum';

export default {
  name: 'ConvertLeadModal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    lead: {
      type: [Object, LeadModel],
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeTab: 0, // 0 = individual, 1 = business
      formData: LeadModel.fromJson(this.lead),
    };
  },
  computed: {
    showModal: {
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit('close');
        }
      },
    },
    isConverted() {
      return Boolean(this.lead?.convertedCustomerId || null);
    },
    canConvertAsIndividual() {
      return this.formData.fullName && this.formData.phoneNumber;
    },
    canConvertAsBusiness() {
      return (
        this.formData.fullName &&
        this.formData.phoneNumber &&
        this.formData.taxCode &&
        this.formData.companyName
      );
    },
    canConvert() {
      if (this.isConverted) {
        return false;
      }
      if (this.activeTab === 0) {
        return this.canConvertAsIndividual;
      } else {
        return this.canConvertAsBusiness;
      }
    },
    customerType() {
      return this.activeTab === 0
        ? CONVERTED_CUSTOMER_TYPE.INDIVIDUAL
        : CONVERTED_CUSTOMER_TYPE.BUSINESS;
    },
  },
  methods: {
    closeModal() {
      this.activeTab = 0;
      this.$emit('close');
    },
    handleConvert() {
      if (!this.canConvert) return;

      this.$emit('convert', {
        customerType: this.customerType,
        leadData: this.formData,
      });
    },
    initializeFormData() {
      if (this.lead) {
        this.formData = LeadModel.fromJson(this.lead);
      }
    },
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.activeTab = 0;
        this.initializeFormData();
      }
    },
    lead: {
      handler() {
        this.initializeFormData();
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.form-label {
  font-weight: 600;
  color: #3f4254;
  margin-bottom: 0.5rem;
}

.form-control-plaintext {
  padding: 0.375rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: #181c32;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
  font-weight: 500;
}

.alert {
  border-radius: 0.42rem;
  padding: 1rem;
  margin-top: 1rem;
}

.alert-success {
  background-color: #e9f7ef;
  border-color: #28a745;
  color: #28a745;
}

.alert-warning {
  background-color: #fff4e6;
  border-color: #ffb020;
  color: #b45b00;
}

.alert i {
  margin-right: 0.5rem;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
}

.tab-content {
  border: 1px solid #e9ecef;
  border-top: none;
  border-radius: 0 0 0.25rem 0.25rem;
}

h5 {
  color: #181c32;
  font-weight: 600;
}

.form-control,
.form-control:focus {
  border-color: #e9ecef;
  box-shadow: none;
  border-radius: 0.42rem;
}

.form-control:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.form-group {
  margin-bottom: 1rem;
}
</style>
